import React from 'react';
import './VerifyEmailView.css';

const IconMail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const IconCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const IconAlert = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
  </svg>
);

/**
 * Presentational verify-email UI: loading, success, error, or resend prompt.
 * Uses HTML/CSS only (no MUI).
 */
export function VerifyEmailView({
  state,
  title,
  copy,
  message,
  messageType,
  resendCooldownSeconds,
  resendLoading,
  onResend,
  primaryActionLabel,
  onPrimaryAction,
  secondaryActionLabel,
  onSecondaryAction,
}) {
  if (state === 'loading') {
    return (
      <div className="verify-email" role="status" aria-live="polite">
        <div className="verify-email__spinner" aria-hidden="true" />
        <p className="verify-email__copy">{copy || 'Processing your request…'}</p>
      </div>
    );
  }

  const isSuccess = state === 'success';
  const isError = state === 'error';
  const isPrompt = state === 'prompt';

  const iconClass =
    isSuccess ? 'verify-email__icon--success' :
    isError ? 'verify-email__icon--error' :
    'verify-email__icon--prompt';

  return (
    <div className="verify-email">
      <div className={`verify-email__icon ${iconClass}`} aria-hidden="true">
        {isSuccess && <IconCheck />}
        {isError && <IconAlert />}
        {isPrompt && <IconMail />}
      </div>
      {title && <h2 className="verify-email__title">{title}</h2>}
      {copy && <p className="verify-email__copy">{copy}</p>}
      {message && (
        <p className={`verify-email__message verify-email__message--${messageType || 'success'}`} role="alert">
          {message}
        </p>
      )}
      <div className="verify-email__actions">
        {onSecondaryAction && secondaryActionLabel && (
          <button
            type="button"
            className="verify-email__btn verify-email__btn--secondary"
            onClick={onSecondaryAction}
          >
            {secondaryActionLabel}
          </button>
        )}
        {isPrompt && onResend && (
          <button
            type="button"
            className="verify-email__btn verify-email__btn--primary"
            onClick={onResend}
            disabled={resendLoading || (resendCooldownSeconds != null && resendCooldownSeconds > 0)}
          >
            {resendCooldownSeconds != null && resendCooldownSeconds > 0
              ? `Resend in ${resendCooldownSeconds}s`
              : resendLoading
                ? 'Sending…'
                : 'Resend verification email'}
          </button>
        )}
        {(isSuccess || isError) && onPrimaryAction && primaryActionLabel && (
          <button
            type="button"
            className="verify-email__btn verify-email__btn--primary"
            onClick={onPrimaryAction}
          >
            {primaryActionLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export default VerifyEmailView;
